export default "https://assets.egbcdn.net/assets/packs/_/images/promo_action/instructions/image3-3ecdffc9176da7d974b7ef3b87faa83d.png";